import {
    SilResultSubsystemBlock,
    SilResultSubsystemBlockCreate,
    SilResultSubsystem,
    SilResultSubsystemCreate,
    SilSubsystem,
    SilSubsystemBlock,
} from "server/models"
import { SilDeviceFilter } from "client/utils"
import { POST } from "client/store/utils"
import { AddSilResultProjectDevice } from "client/store"

export const LoadSilResultSubsystemBlocksByFilter = (filters: SilDeviceFilter) => (
    POST(
        "/silResultSubsystemBlock/getByFilter",
        JSON.stringify(filters),
    ).then((blocks: SilResultSubsystemBlock[]) => blocks)
)

export const AddSilResultSubsystem = (subsystem: SilResultSubsystemCreate) => (
    POST(
        "/silResultSubsystem/add",
        JSON.stringify(subsystem),
    ).then((res) => {
        const newSubsystem = res as SilResultSubsystem
        return newSubsystem.id || null
    })
)

export const AddSilResultSubsystemBlock = (block: SilResultSubsystemBlockCreate) => (
    POST(
        "/silResultSubsystemBlock/add",
        JSON.stringify(block),
    )
)

export const SaveSilResultSubsystems = (
    safetyFunctionId: number,
    projectId: number,
    subsystemList: readonly SilSubsystem[],
) => {
    const allBlocks: SilSubsystemBlock[] = []
    let indexOneByOne: number

    const addDevicesOneByOne = (): any => {
        /*
            Add result project devices one by one.
            If to use "Promise.all" and there are several the same devices in the list -
            the system will add all of them to the DB
        */
        const block = allBlocks[indexOneByOne]
        if (block) {
            const filters: SilDeviceFilter = {
                projectId,
                deviceId: block.deviceId,
                projectDeviceId: block.projectDeviceId,
                qidProductId: block.qidProductId,
                qidModelId: block.qidModelId,
                qidSafetyFunctionId: block.qidSafetyFunctionId,
                qidOptionId: block.qidOptionId,
                qidDatapointId: block.qidDatapointId,
                qidMethod: block.qidMethod,
            }
            return AddSilResultProjectDevice(filters).then(() => {
                indexOneByOne += 1
                return addDevicesOneByOne()
            })
        }
        return null
    }

    // save subsystems and blocks
    const promiseAddSubsystems: Promise<any>[] = []
    subsystemList.forEach((subsystem, subsystemIndex) => {
        const newSubsystem = {
            ...subsystem,
            safetyFunctionId,
            order: subsystemIndex,
        }
        delete newSubsystem.id // important! clear old ID

        promiseAddSubsystems.push(
            AddSilResultSubsystem(newSubsystem).then((newSubsystemId) => {
                const promiseAddBlocks: Promise<any>[] = []
                subsystem.blocks.forEach((block, blockIndex) => {
                    const newBlock = {
                        ...block,
                        subsystemId: newSubsystemId,
                        order: blockIndex,
                    }
                    delete newBlock.id // important! clear old ID

                    promiseAddBlocks.push(
                        AddSilResultSubsystemBlock(newBlock),
                    )
                    allBlocks.push(block)
                })

                return Promise.all(promiseAddBlocks)
            }),
        )
    })

    return Promise.all(promiseAddSubsystems).then(() => {
        // insert project devices to result table
        indexOneByOne = 0
        return addDevicesOneByOne()
    })
}
